function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashedGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 3,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009c8d",
      stroke: "none"
    },
    d: "M11 0L11 3L8 100L6 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009c8d",
      stroke: "none"
    },
    d: "M14 0L14 3L19 3L19 0L11 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009c8d",
      stroke: "none"
    },
    d: "M22 0L22 3L30 3L30 0L22 0z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashedGreen);
export default __webpack_public_path__ + "static/media/dashedGreen.c8e39a15ad130c572848685107e66aa2.svg";
export { ForwardRef as ReactComponent };